import React from "react";

var StarIcon = function StarIcon(_ref) {
  var size = _ref.size,
      foregroundColor = _ref.foregroundColor,
      backgroundColor = _ref.backgroundColor,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.571 17.188c0 .392-.232.82-.696 1.285l-9.723 9.482 2.303 13.393c.018.125.027.304.027.536 0 .375-.094.692-.281.95-.188.26-.46.39-.817.39-.34 0-.696-.108-1.072-.322L22.287 36.58l-12.027 6.322c-.393.214-.75.321-1.072.321-.375 0-.656-.13-.843-.388-.188-.26-.281-.576-.281-.951 0-.107.017-.286.053-.536l2.304-13.393-9.75-9.482c-.447-.482-.67-.91-.67-1.285 0-.661.5-1.072 1.5-1.233L14.946 14l6.027-12.188c.34-.732.777-1.098 1.313-1.098.535 0 .973.366 1.312 1.099L29.625 14l13.446 1.955c1 .161 1.5.572 1.5 1.232z",
    fill: backgroundColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.286.714V36.58l-12.027 6.322c-.393.214-.75.321-1.072.321-.375 0-.656-.13-.843-.388-.188-.26-.281-.576-.281-.951 0-.107.017-.286.053-.536l2.304-13.393-9.75-9.482c-.447-.482-.67-.91-.67-1.285 0-.661.5-1.072 1.5-1.233L14.946 14l6.027-12.188c.34-.732.777-1.098 1.313-1.098z",
    fill: foregroundColor
  })));
};

export { StarIcon };